import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { get, post } from "./common/http";
import { API_ENDPOINTS } from "./Utils/endpoints";

export const GetWarehouseDetail = (params: any) =>
  GET_ENC(API_ENDPOINTS.WAREHOUSE.GET_DETAIL + params, null);

export const GetWarehouseList = (params: any) =>
  GET_ENC(API_ENDPOINTS.WAREHOUSE.GET_LIST + params, null);

export const CreateWarehouse = (data: any) =>
  POST_ENC(API_ENDPOINTS.WAREHOUSE.CREATE, data);

export const UpdateWarehouse = (data: any) =>
  POST_ENC(API_ENDPOINTS.WAREHOUSE.UPDATE, data);

export const DeleteWarehouse = (data: any) =>
  POST_ENC(API_ENDPOINTS.WAREHOUSE.DELETE, data);

export const UpdateDefaultWarehouse = (params: any) =>
  POST_ENC(API_ENDPOINTS.WAREHOUSE.UPDATE_DEFAULT, params);
